import { useNavigate } from "react-router-dom";

import TileTitle from "ds/components/Tile/Title";
import { IconComponent } from "types/Icon";
import TileWrapper from "ds/components/Tile/Wrapper";
import TileContent from "ds/components/Tile/Content";
import IconEmphasized from "ds/components/IconEmphasized";
import Box from "ds/components/Box";
import { AnalyticsPageLaunchpad } from "hooks/useAnalytics/pages/launchpad";
import useAnalytics from "hooks/useAnalytics";
import TileDescription from "ds/components/Tile/Description";
import Icon from "ds/components/Icon";
import { Clock } from "components/icons/generated";
import Typography from "ds/components/Typography";
import ProgressBar from "ds/components/ProgressBar";
import BadgeNext from "ds/components/BadgeNext";
import { UserGuideGroupSkillLevel } from "types/generated";

type LaunchPadLearnGroupTileProps = {
  title: string;
  icon: IconComponent;
  backgroundColor: string;
  to: string;
  skillLevel?: UserGuideGroupSkillLevel;
  description: string;
  timeToComplete: string;
  guidesCount: number;
  guidesCompletedCount: number;
};

const LaunchPadLearnGroupTile = ({
  title,
  icon,
  backgroundColor,
  to,
  skillLevel,
  description,
  timeToComplete,
  guidesCount,
  guidesCompletedCount,
}: LaunchPadLearnGroupTileProps) => {
  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageLaunchpad.Launchpad,
  });

  const navigate = useNavigate();

  const handleClick = () => {
    trackSegmentAnalyticsEvent(`Learn ${title} clicked`);
    navigate(to);
  };

  return (
    <TileWrapper onClick={handleClick}>
      <TileContent direction="column" align="start">
        <Box justify="between" fullWidth align="center">
          <IconEmphasized icon={icon} backgroundColor={backgroundColor} />
          <BadgeNext type="weak" variant="gray" text={skillLevel} />
        </Box>
        <Box direction="column" gap="small" fullWidth grow="1" justify="between">
          <Box direction="column" gap="small">
            <TileTitle>{title}</TileTitle>
            <TileDescription>{description}</TileDescription>
          </Box>
          <Box padding="small 0 0 0" fullWidth align="center" justify="between">
            <Box direction="row" align="center" gap="small">
              <Icon src={Clock} color="secondary" />
              <Typography color="secondary" variant="p-body3" tag="span">
                {timeToComplete} left
              </Typography>
            </Box>
            <ProgressBar
              ariaLabel="Scenario group completion progress"
              max={guidesCount}
              current={guidesCompletedCount}
              isPercentage
            />
          </Box>
        </Box>
      </TileContent>
    </TileWrapper>
  );
};

export default LaunchPadLearnGroupTile;
